import firebase from '../config/firebase';
import shipperService from './shipper.service';

const db = firebase.firestore();

const mapUserDocToSeller = (doc) => ({
    id: doc.id,
    name: doc.data().name,
    isSeller: Boolean(doc.data().isSeller),
    uidShipper: doc.data().uidShipper || "",
    email: doc.data().email || "",
    phoneNumber: doc.data().phoneNumber || "",
    phoneNumberFirst: doc.data().phoneNumberFirst || "",
    phone: doc.data().phone || "",
    telefone: doc.data().telefone || "",
    photoURL: doc.data().photoURL || "",
    photoUrl: doc.data().photoUrl || "",
    file: doc.data().file || "",
});

const userService = {

    async getUsers() {
        try {
            const snapshot = await db.collection('user_web').get();
            const users = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            return users;
        }
        catch (error) {
            console.error("Error getting documents: ", error);
            throw error;
        }
    },

    async updateUser(userId, userData) {
        try {
            await db.collection('user_web').doc(userId).update(userData);
        }
        catch (error) {
            console.error("Error updating document: ", error);
            throw error;
        }
    },

    async updateUserPerfil(perfil, permissions, selecionarTodosGeral) {
        try {
            const snapshot = await db.collection('user_web')
                .where('perfil', '==', perfil)
                .get();

            if (snapshot.empty) {
                console.log("Nenhum usuário encontrado com esse perfil.");
                return;
            }

            // Usa batch para fazer tudo de uma vez (melhor performance)
            const batch = db.batch();

            snapshot.docs.forEach(doc => {
                const userRef = db.collection('user_web').doc(doc.id);
                batch.update(userRef, { permissoes: permissions, permissoesAll: selecionarTodosGeral });
            });

            await batch.commit();
            console.log("Permissões atualizadas com sucesso para todos os usuários do perfil:", perfil);
        } catch (error) {
            console.error("Erro ao atualizar documentos:", error);
            throw error;
        }
    },


    getShipperIdsFromUser(user) {
        const affiliateUids = Array.isArray(user?.uidShipperAffiliates)
            ? user.uidShipperAffiliates
            : [];
        const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
        return Array.from(new Set([...affiliateUids, ...primaryUid])).filter(Boolean);
    },

    /**
     * Resolve o e-mail de pagamento configurado no cadastro do embarcador.
     */
    async getPaymentEmailByShipperId(shipperId) {
        if (!shipperId) return null;

        try {
            const shipperDoc = await db.collection("shipper").doc(shipperId).get();
            if (!shipperDoc.exists) return null;

            const paymentEmailUserId = shipperDoc.data()?.financial?.paymentEmailUser;
            if (!paymentEmailUserId) return null;

            const userDoc = await db.collection("user_web").doc(paymentEmailUserId).get();
            if (!userDoc.exists) return null;

            const email = String(userDoc.data()?.email || "").trim();
            return email || null;
        } catch (error) {
            console.error("Error resolving payment email by shipper id: ", error);
            throw error;
        }
    },

    /**
     * Retorna usuários vinculados aos embarcadores informados.
     */
    async getUsersByShipperIds(shipperIds) {
        const uids = Array.from(new Set((shipperIds || []).filter(Boolean)));
        if (uids.length === 0) return [];

        const CHUNK_SIZE = 10;
        const chunks = [];
        for (let i = 0; i < uids.length; i += CHUNK_SIZE) {
            chunks.push(uids.slice(i, i + CHUNK_SIZE));
        }

        try {
            const snapshots = await Promise.all(
                chunks.map((chunk) =>
                    db.collection("user_web")
                        .where("uidShipper", "in", chunk)
                        .get()
                )
            );

            const seen = new Set();
            const users = [];

            snapshots.forEach((snapshot) => {
                snapshot.docs.forEach((doc) => {
                    if (seen.has(doc.id)) return;
                    seen.add(doc.id);
                    users.push(mapUserDocToSeller(doc));
                });
            });

            return users.sort((a, b) =>
                String(a.name || "").localeCompare(String(b.name || ""), "pt-BR")
            );
        } catch (error) {
            console.error("Error getting users by shipper ids: ", error);
            throw error;
        }
    },

    /**
     * Retorna vendedores (isSeller) vinculados aos embarcadores informados.
     */
    async getSellersByShipperIds(shipperIds) {
        const uids = Array.from(new Set((shipperIds || []).filter(Boolean)));
        if (uids.length === 0) return [];

        const CHUNK_SIZE = 10;
        const chunks = [];
        for (let i = 0; i < uids.length; i += CHUNK_SIZE) {
            chunks.push(uids.slice(i, i + CHUNK_SIZE));
        }

        try {
            const snapshots = await Promise.all(
                chunks.map((chunk) =>
                    db.collection("user_web")
                        .where("isSeller", "==", true)
                        .where("uidShipper", "in", chunk)
                        .get()
                )
            );

            const seen = new Set();
            const sellers = [];

            snapshots.forEach((snapshot) => {
                snapshot.docs.forEach((doc) => {
                    if (seen.has(doc.id)) return;
                    seen.add(doc.id);
                    sellers.push(mapUserDocToSeller(doc));
                });
            });

            return sellers.sort((a, b) =>
                String(a.name || "").localeCompare(String(b.name || ""), "pt-BR")
            );
        } catch (error) {
            console.error("Error getting sellers by shipper ids: ", error);
            throw error;
        }
    },

    /**
     * Retorna uma lista de usuários associados com o Fortio.
     * 
     * @param {string} userId - ID do usuário atual
     * @returns {object[]} - uma lista de objetos que contém o ID e o nome dos usuários associados com o Fortio
     * @throws {Error} - lança um erro se ocorrer algum problema durante a execução da função
     */
    async usersAssociatedWithFortio() {
        try {

            const result = await db.collection("user_web")
            // .where("uidShipper", "==", resultShipper.id)
            .get();
            
            const list = result.docs.map(mapUserDocToSeller);

            return list;
        }
        catch (error) {
            console.error("Error deleting document: ", error);
            throw error;
        }
    }
}

export default userService;